import { Howl, Howler } from 'howler'
import Manifest from '../manifest'
import when from "when"


const LOOP_PARAMS = [
    { 
        name: "ambiant-loop-0",
        in: 0,
        out: 0.07,
        active: false,
    },
    { 
        name: "ambiant-loop-1",
        in: 0.07,
        out: 0.19,
        active: false,
    },
    { 
        name: "ambiant-loop-2",
        in: 0.17,
        out: 0.58,
        active: false,
    },
    { 
        name: "ambiant-loop-3",
        in: 0.45,
        out: 0.75,
        active: false,
    },
]


class SoundController {
    constructor() {
        this.sounds = {}
        this.muted = false
        Howler.volume(0.5)
        this.initEvents()
    }

    initEvents(){
        window.addEventListener('blur', () => {
            Howler.volume(0)
        })
        window.addEventListener('focus', ()=>{
            if (this.muted == false) {
                Howler.volume(0.5)
            }
        })
    }

    getLoadables() {
        let promises = []
        for (const key in Manifest.audio) {
            if (Manifest.audio.hasOwnProperty(key)) {
                let promise = when.defer()
                let audio = new Howl({
                    src: [Manifest.audio[key]],
                    html5: false
                })
                promises.push(promise)
                this.sounds[key] = {
                    audio: audio,
                    defer: promise,
                    loop: false,
                    looping: false,
                    playing: false,
                    playTime: null
                }
                audio.once('load', function () {
                    promise.resolve(audio)
                })
            }
        }
        when.all(promises).then(() => {
            this.onLoaded()
        })
        return promises
    }

    onLoaded() {

    }

    play(id) {
        if (this.sounds[id] && this.sounds[id].audio) {
            this.sounds[id].audio.seek(0)
            this.sounds[id].audio.play()
        }
    }

    stop(id) {
        if (this.sounds[id] && this.sounds[id].audio) {
            this.sounds[id].audio.stop()
            this.sounds[id].playTime = null
        }
    }

    toggleMute() {
        if (!this.muted) {
            Howler.volume(0)
        } else {
            Howler.volume(0.5)
        }
        this.muted = !this.muted
    }

    setVolume(id, vol) {
        if (this.sounds[id] && this.sounds[id].audio) {
            this.sounds[id].audio.volume(vol)
        }
    }

    fadeTo(id, vol, time){
        if (this.sounds[id] && this.sounds[id].audio) {
            this.sounds[id].audio.fade(0, vol, time)
        }
    }

    fadeIn(id) {
        if (this.sounds[id] && this.sounds[id].audio) {
            this.sounds[id].audio.seek(0)
            this.sounds[id].audio.play()
            this.sounds[id].audio.fade(0, 0.5, 1000)
            this.sounds[id].playing = true
            this.sounds[id].playTime = Date.now()
        }
    }

    fadeOut(id) {
        if (this.sounds[id] && this.sounds[id].audio) {
            this.sounds[id].audio.fade(0.5, 0, 2000)
            this.sounds[id].playing = false
            setTimeout(() => {
                this.sounds[id].audio.stop()
                this.sounds[id].playTime = null
            }, 1500);
        }
    }

    playAndLoop(id) {
        if (this.sounds[id] && this.sounds[id].audio && !this.sounds[id].looping) {
            this.sounds[id].audio.loop(true)
            this.sounds[id].audio.play()
            this.sounds.looping = true
            this.sounds.playing = true
        }
    }

    updateProgress(progress){
        for (let i = 0; i < LOOP_PARAMS.length; i++) {
            const params = LOOP_PARAMS[i];
            if (progress > params.in && progress < params.out) {
                if (params.active == false) {
                    params.active = true
                    this.setVolume(params.name, 0)
                    this.playAndLoop(params.name)
                    this.fadeTo(params.name, 1, 1000)
                }
            } else {
                if (params.active == true) {
                    params.active = false
                    this.fadeOut(params.name)
                }
            }
        }
    }
}

const out = new SoundController()
export default out